module.exports = __webpack_public_path__ + "img/765f899.png";